export default __webpack_public_path__ + "static/media/popup card.e25b7f8c.svg";